// removed by extract-text-webpack-plugin
module.exports = {"activeGoalDetailContainer":"activeGoalDetailContainer-1WeRj","totalsContainer":"totalsContainer-Jdgn-","goalDuration":"goalDuration-Bv2ew","stopGoalContainer":"stopGoalContainer-3KzL-","stopGoal":"stopGoal-1bhrS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/goals/view/_activeGoalDetails.css
// module id = 1203
// module chunks = 1